import React from "react";
import { Stack, Box, Typography, Skeleton } from "@mui/material";

/**
 * Mini-stat cards de distribución de recall.
 * 4 cards: 12+Mo, 9Mo, 6Mo, Contactable Phone.
 */
export default function RecallStats({ distribution, contactability, loading }) {
  if (loading) {
    return (
      <Stack direction="row" spacing={1.5}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} variant="rounded" width={100} height={56} />
        ))}
      </Stack>
    );
  }

  const stats = [
    { label: "12+ Months", value: distribution?.months12plus || 0, color: "#DC2626", bg: "#FEE2E2" },
    { label: "9 Months", value: distribution?.months9 || 0, color: "#9A3412", bg: "#FFEDD5" },
    { label: "6 Months", value: distribution?.months6 || 0, color: "#92400E", bg: "#FEF3C7" },
    { label: "With Phone", value: contactability?.withPhone || 0, color: "#166534", bg: "#F0FDF4" },
  ];

  return (
    <Stack direction="row" spacing={1.5} sx={{ flexWrap: "wrap" }}>
      {stats.map((s) => (
        <Box
          key={s.label}
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: s.bg,
            minWidth: 90,
            textAlign: "center",
            flex: "1 1 auto",
          }}
        >
          <Typography variant="h6" fontWeight={800} sx={{ color: s.color, lineHeight: 1.1 }}>
            {s.value.toLocaleString()}
          </Typography>
          <Typography variant="caption" sx={{ fontSize: "0.62rem", color: s.color }}>
            {s.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
